/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ReassignKindFromJSON, ReassignKindToJSON, UserFromJSON, UserToJSON, } from './';
export function WorkorderReassignCommandFromJSON(json) {
    return WorkorderReassignCommandFromJSONTyped(json, false);
}
export function WorkorderReassignCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'targetWorkerName': !exists(json, 'targetWorkerName') ? undefined : json['targetWorkerName'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'reassignType': !exists(json, 'reassignType') ? undefined : ReassignKindFromJSON(json['reassignType']),
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
    };
}
export function WorkorderReassignCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'targetWorkerName': value.targetWorkerName,
        'reason': value.reason,
        'reassignType': ReassignKindToJSON(value.reassignType),
        'user': UserToJSON(value.user),
    };
}
